/* ============================================================
   THE BEAUTY SHOP — theme.js
   Vanilla JS. No frameworks. Mobile-first interactions.
   ============================================================ */

(function () {
  'use strict';

  /* ---------- Helpers ---------- */
  const $ = (s, root) => (root || document).querySelector(s);
  const $$ = (s, root) => Array.from((root || document).querySelectorAll(s));
  const on = (el, ev, fn) => el && el.addEventListener(ev, fn);
  const formatMoney = (cents) => {
    if (typeof window.Shopify !== 'undefined' && window.Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme && theme.moneyFormat);
    }
    return ((cents || 0) / 100).toFixed(2);
  };

  /* ---------- Drawer controller ---------- */
  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    const overlay = $('.drawer-overlay');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach((d) => {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    const overlay = $('.drawer-overlay');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
  }
  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer(openBtn.getAttribute('data-drawer-open'));
      if (openBtn.getAttribute('data-drawer-open') === 'cart-drawer') {
        refreshCartDrawer();
      }
    }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer-overlay')) {
      closeDrawers();
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Sticky transparent header ---------- */
  const header = $('[data-header]');
  if (header && header.classList.contains('site-header--transparent')) {
    const onScroll = () => {
      if (window.scrollY > 80) header.classList.add('is-stuck');
      else header.classList.remove('is-stuck');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Product gallery thumb selection ---------- */
  $$('[data-product-thumb]').forEach((t) => {
    on(t, 'click', () => {
      const galleryId = t.getAttribute('data-gallery');
      const src = t.getAttribute('data-src');
      const alt = t.getAttribute('data-alt') || '';
      const main = document.getElementById(galleryId);
      if (main && src) {
        const img = main.querySelector('img');
        if (img) { img.src = src; img.alt = alt; }
      }
      $$('[data-gallery="' + galleryId + '"]').forEach((x) => x.classList.remove('is-active'));
      t.classList.add('is-active');
    });
  });

  /* ---------- Quantity stepper ---------- */
  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-qty-minus]');
    const plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    const wrap = (minus || plus).closest('[data-qty]');
    if (!wrap) return;
    const input = wrap.querySelector('input');
    let v = parseInt(input.value || '1', 10) || 1;
    if (minus) v = Math.max(1, v - 1);
    if (plus) v = v + 1;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Add to cart (ajax) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[data-product-form]')) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = (window.theme && theme.strings && theme.strings.adding) || 'Adding...'; }
    const fd = new FormData(form);
    try {
      const res = await fetch(window.theme.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Could not add to cart');
      }
      await refreshCartDrawer();
      openDrawer('cart-drawer');
    } catch (err) {
      alert(err.message);
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; }
    }
  });

  /* ---------- Cart line update / remove ---------- */
  document.addEventListener('click', async (e) => {
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      const key = remove.getAttribute('data-cart-remove');
      await cartChange(key, 0);
    }
  });
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    const key = input.getAttribute('data-cart-qty');
    const qty = parseInt(input.value, 10) || 1;
    await cartChange(key, qty);
  });

  async function cartChange(key, quantity) {
    try {
      const res = await fetch(window.theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!res.ok) throw new Error('cart update failed');
      await refreshCartDrawer();
    } catch (err) {
      console.error(err);
    }
  }

  async function refreshCartDrawer() {
    try {
      const [cartRes, sectionRes] = await Promise.all([
        fetch(window.theme.routes.cart + '.js', { headers: { 'Accept': 'application/json' } }),
        fetch('?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
      ]);
      const cart = await cartRes.json();
      // Update bubble count
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      if (sectionRes.ok) {
        const html = await sectionRes.text();
        const wrap = document.createElement('div');
        wrap.innerHTML = html;
        const newDrawer = wrap.querySelector('#cart-drawer');
        const current = document.getElementById('cart-drawer');
        if (newDrawer && current) {
          // preserve open state
          const wasOpen = current.classList.contains('is-open');
          current.innerHTML = newDrawer.innerHTML;
          if (wasOpen) current.classList.add('is-open');
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  /* ---------- Predictive search ---------- */
  let searchTimer;
  document.addEventListener('input', (e) => {
    const input = e.target.closest('[data-predictive-search]');
    if (!input) return;
    clearTimeout(searchTimer);
    const q = input.value.trim();
    const target = $('[data-predictive-results]');
    if (!target) return;
    if (q.length < 2) { target.innerHTML = ''; return; }
    searchTimer = setTimeout(async () => {
      try {
        const res = await fetch(`${window.theme.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`, {
          headers: { 'Accept': 'text/html' }
        });
        const html = await res.text();
        const w = document.createElement('div');
        w.innerHTML = html;
        const inner = w.querySelector('[data-predictive-inner]');
        target.innerHTML = inner ? inner.innerHTML : '';
      } catch (err) { console.error(err); }
    }, 220);
  });

  /* ---------- Newsletter inline success message ---------- */
  // Shopify renders ?customer_posted=true on success, but the message lives in HTML already.

  /* ---------- Localization form auto-submit ---------- */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-locale-select], [data-currency-select]');
    if (sel) sel.form && sel.form.submit();
  });
})();

/* === LUXURY REFINEMENT LAYER === */
(function(){
  'use strict';

  // 1. Reveal-on-scroll via IntersectionObserver
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    function bindReveals(root) {
      (root || document).querySelectorAll('[data-reveal]:not(.is-visible)').forEach(function(el) {
        revealObserver.observe(el);
      });
    }
    bindReveals();

    // Re-bind after section editor reloads
    document.addEventListener('shopify:section:load', function(e) { bindReveals(e.target); });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function(el) { el.classList.add('is-visible'); });
  }

  // 2. Header scroll refinement — passive listener, throttled with rAF
  var header = document.querySelector('[data-header]');
  if (header) {
    var lastY = 0, ticking = false;
    function updateHeader() {
      var y = window.scrollY || 0;
      if (y > 60) header.classList.add('is-stuck');
      else header.classList.remove('is-stuck');
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
    updateHeader();
  }
})();
